import { render, staticRenderFns } from "./student-attendance.vue?vue&type=template&id=605c9aa8&scoped=true&"
import script from "./student-attendance.vue?vue&type=script&lang=js&"
export * from "./student-attendance.vue?vue&type=script&lang=js&"
import style0 from "./student-attendance.vue?vue&type=style&index=0&id=605c9aa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c9aa8",
  null
  
)

export default component.exports